import { useEffect } from 'react';
import { useHistory } from 'react-router';

import ExpertPage from '@components/pageTypes/ExpertPage';
import { isNotNativeApp } from '@utils/platformUtils';

const ExpertCommunityPage = () => {
  const history = useHistory();

  useEffect(() => {
    if (isNotNativeApp()) {
      window.location.href = 'https://gather.withgrayce.com/';
    } else {
      history.push('/expert/dashboard');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ExpertPage
      helmetKey="pageTitles.expert.community.show"
      imageName="peopleHoldingHearts"
      titleKey="pages.expert.community.title"
    />
  );
};

export default ExpertCommunityPage;
